import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CContainer, CHeader, CHeaderBrand, CHeaderDivider, CHeaderNav, CHeaderToggler, CNavLink, CNavItem, } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBell, cilEnvelopeOpen, cilList, cilMenu } from '@coreui/icons'
import { VendorReducer } from 'shared/redux/reducers/vendor/VendorReducer'
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import style from "./ManagerHeader.module.css";
import ManagerHeaderDropdown from './ManagerHeaderDropdown'

const ManagerHeader = () => {
  const { isMobile } = useContext(BrowserDetectContext);
  const dispatch = useDispatch();
  // const sidebarShow = useSelector((state) => state.sidebarShow)
  const { sidebarShow } = useSelector((state) => ({ sidebarShow: state.vendor.sidebarShow }));

  const onSidebarTogglerClick = () => {
    dispatch(VendorReducer.actions.toggleSideBar(!sidebarShow));
  }

  return (
    <CHeader position="sticky">
      <CContainer fluid>
        {
          isMobile &&
          <CHeaderToggler className="ps-1" onClick={onSidebarTogglerClick} >
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
        }
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          로고자리
          {/* <CIcon icon={logo} height={48} alt="Logo" /> */}
        </CHeaderBrand>
        {
          isMobile ? <>
          <CHeaderNav className="d-none d-md-flex me-auto">
              {/* <CNavItem>
            <CNavLink to="/vendor" component={NavLink}>
              대시보드
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Settings</CNavLink>
          </CNavItem> */}
            </CHeaderNav>
            <CHeaderNav>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilBell} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilList} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilEnvelopeOpen} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                {
                  // isMobile ? <MobileLanguageSwitcher /> : <DesktopLanguageSwitcher />
                }
              </CNavItem>
            </CHeaderNav>
            <CHeaderNav className="ms-3">
              <ManagerHeaderDropdown />
            </CHeaderNav>
          </>
          :<div className={style.navContainer}>
          <div className={style.nav}>
            <CHeaderNav className="d-none d-md-flex me-auto">
              {/* <CNavItem>
            <CNavLink to="/vendor" component={NavLink}>
              대시보드
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Settings</CNavLink>
          </CNavItem> */}
            </CHeaderNav>
            <CHeaderNav>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilBell} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilList} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="#">
                  <CIcon icon={cilEnvelopeOpen} size="lg" />
                </CNavLink>
              </CNavItem>
              <CNavItem>
                {
                  // isMobile ? <MobileLanguageSwitcher /> : <DesktopLanguageSwitcher />
                }
              </CNavItem>
            </CHeaderNav>
            <CHeaderNav className="ms-3">
              <ManagerHeaderDropdown />
            </CHeaderNav>
          </div>

        </div>
        }
        

      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        {/* <VendorBreadcrumb /> */}
      </CContainer>
    </CHeader>
  )
}

export default ManagerHeader
